export const environment = {
  production: false,
  apiUrl: 'https://gaspruebas.canteradigital.mx/api',
  authUrl: 'https://gaspruebas.canteradigital.mx/auth',
  baseUrl: 'https://gaspruebasv2.canteradigital.mx/',
  storageRecordsUrl: 'https://gaspruebas.canteradigital.mx/storage/records/',
};
